import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { ProcessSteps } from "@/components/ProcessSteps";
import { Faq } from "@/components/Faq";
import { FinalCta } from "@/components/FinalCta";
import { BUSINESS } from "@/data/site";

export default function Process() {
  useEffect(() => { document.title = `Our Process — ${BUSINESS.name}`; }, []);
  return (
    <>
      <PageHero
        overline="Process"
        titleLines={["A clear path from", "idea to launch."]}
        subtitle="Seven simple steps, zero surprises — delivered by a team that treats your business like our own."
      />
      <ProcessSteps heading={false} />
      <Faq />
      <FinalCta />
    </>
  );
}
